import '@babel/polyfill';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import messages from '@/lang/messages';
import vuetify from '@/plugins/vuetify';
import './plugins';

import router from './router';
import store from '@/store';

import App from './App.vue';
import stomp from '@/services/StompService';
import Storage from './utils/storage';
Vue.prototype.$stomp = stomp;

Vue.config.productionTip = false;

var storage = Storage;

storage
  .loadKey(['oauth', 'user'])
  .catch(e => {
    console.log(e); // eslint-disable-line
  })
  .finally(() => {
    const app = new Vue({
      vuetify,
      router,
      store,
      data: () => ({ loading: true }),
      mounted() {
        this.loading = false;
      },
      i18n: new VueI18n({
        fallbackLocale: 'fr_FR',
        locale: (navigator.language || 'fr_FR').replace('-', '_'),
        silentTranslationWarn: true,
        messages,
      }),
      render: h => h(App),
    });
    store.$app = app;
    app.$mount('#app');
  });
